import { tableDe } from './table-de';
import { tableEn } from './table-en';
import { tablePl } from './table-pl';
export * from './useTableTranslation';

export const tableTranslations = {
  de: tableDe,
  en: tableEn,
  pl: tablePl,
};
